import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import convert from 'htmr'

// eslint-disable-next-line react/prop-types
function Paragraph({ children }) {
  if (!children) return null
  // eslint-disable-next-line react/prop-types
  const cleanedChildren = children.filter((child) => {
    if (typeof child === 'string') return Boolean(child.trim())
    return true
  })
  return (
    <p className="demibolden-children mb-24 last:mb-0 md:mb-36">
      {cleanedChildren}
    </p>
  )
}

const transform = {
  // eslint-disable-next-line react/prop-types
  h1: function Heading1({ children }) {
    return (
      <h2 className="type-large my-24 leading-default last:mb-0 md:my-32">
        {children}
      </h2>
    )
  },
  // eslint-disable-next-line react/prop-types
  h2: function Heading2({ children }) {
    return (
      <h2 className="type-large my-24 leading-default last:mb-0 md:my-32">
        {children}
      </h2>
    )
  },
  // eslint-disable-next-line react/prop-types
  h3: function Heading3({ children }) {
    return (
      <h2 className="type-med my-24 leading-default last:mb-0 md:my-32 ">
        {children}
      </h2>
    )
  },
  // eslint-disable-next-line react/prop-types
  h4: function Heading4({ children }) {
    return (
      <h2 className="my-24 font-demibold leading-default last:mb-0 md:my-32">
        {children}
      </h2>
    )
  },
  // eslint-disable-next-line react/prop-types
  ul: function Ul({ children }) {
    return <ul className="mb-24 pl-16 md:mb-32">{children}</ul>
  },
  // eslint-disable-next-line react/prop-types
  li: function Li({ children }) {
    return <li className="mb-12 list-disc last:mb-0 md:mb-16">{children}</li>
  },
  p: Paragraph,

  // eslint-disable-next-line react/prop-types
  a: function Anchor({ href, children, download }) {
    return (
      <a
        href={href}
        className="border-b-1 border-blue-light text-blue-dark transition hover:border-Type hover:text-Type"
        download={download}
      >
        {children}
      </a>
    )
  },
  // eslint-disable-next-line react/prop-types
  img: function Image({ src }) {
    return <img src={src} className="mb-24" />
  },
}

export default function TextBlock(props) {
  return (
    <div
      className={classNames('clean-br w-full leading-body', {
        'text-center': props.centeredText,
      })}
    >
      {convert(props.bodyCopy, { transform })}
    </div>
  )
}

TextBlock.propTypes = {
  bodyCopy: PropTypes.string,
  centeredText: PropTypes.bool,
}
